import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {ArrDrawer} from '../../../../../common/arr-drawer/ArrDrawer';
import './NonEditableFieldFlyout.scss';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

type NonEditableFieldItem = {
  fieldId: number;
  fieldName: string;
  fieldType: string;
};

type NonEditableFieldFlyoutProps = {
  isOpen: boolean;
  onClose: () => void;
  nonEditableFields?: NonEditableFieldItem[];
};

const NonEditableFieldFlyout: React.FC<NonEditableFieldFlyoutProps> = (
  props
) => {
  const {isOpen, onClose, nonEditableFields = []} = props;
  const {t} = useTranslation();

  const rows = useMemo(() => {
    return [...nonEditableFields]?.sort((a, b) =>
      a?.fieldName.localeCompare(b.fieldName)
    );
  }, [nonEditableFields]);

  return (
    <ArrDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={t('indexManagement.customIndex.selectAnalyzer.nonEditableFields', {
        count: rows.length,
      })}
      side="right"
      showButton
      size="small"
      className="non-editable-field-flyout"
    >
      <Box className="non-editable-field-flyout__container">
        <Table aria-label="non-editable-fileds-flyout">
          <TableHead>
            <TableRow>
              <TableCell
                tabIndex={0}
                className="non-editable-field-flyout-header typo-text label2_size"
              >
                {t('indexManagement.customIndex.selectAnalyzer.fieldName')}
              </TableCell>
              <TableCell
                tabIndex={0}
                className="non-editable-field-flyout-header typo-text label2_size"
              >
                {t('indexManagement.customIndex.selectAnalyzer.fieldType')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row) => (
              <TableRow key={row.fieldId}>
                <TableCell
                  tabIndex={0}
                  className="non-editable-field-flyout-table-row typo-text body3_size"
                >
                  {row.fieldName}
                </TableCell>
                <TableCell
                  tabIndex={0}
                  className="non-editable-field-flyout-table-row typo-text body3_size"
                >
                  {row.fieldType}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </ArrDrawer>
  );
};

export default NonEditableFieldFlyout;
